<template>
	<div
		v-if="dialogs.confirmationModal.open"
		class="z-maximumPlusUltraMinusOne fixed top-0 table h-full w-full bg-black/50"
	>
		<div class="table-cell align-middle">
			<div
				class="relative mx-auto max-w-sm rounded-xl bg-white px-4 py-6 shadow-lg md:max-w-md lg:max-w-lg lg:px-5"
			>
				<div
					class="absolute right-4 top-4 h-6 w-6 cursor-pointer"
					@click="handleDialogsClose"
				>
					<CloseSvg class="fill-secondary" />
				</div>

				<div class="mb-8">
					<h3 class="text-main-400 text-20 md:text-24 lg:text-28 text-center font-bold">
						{{ dialogs.confirmationModal.title }}
					</h3>

					<div class="text-primary text-center text-base lg:text-xl">
						{{ dialogs.confirmationModal.subtitle }}
					</div>
				</div>

				<div class="flex flex-wrap justify-center gap-4 md:justify-between">
					<AppButton
						class="xs:basis-0 text-md min-w-[unset] md:min-w-[unset] lg:min-w-[unset]"
						size="Small"
						@click="handleDialogsClose"
					>
						<span v-if="!loading">{{ dialogs.confirmationModal.cancelButton }}</span>

						<SpinnerSvg v-else class="fill-white" />
					</AppButton>

					<AppButton
						class="xs:basis-0 text-md min-w-[unset] md:min-w-[unset] lg:min-w-[unset]"
						size="Small"
						@click="onConfirm"
					>
						<span v-if="!loading">{{ dialogs.confirmationModal.confirmButton }}</span>

						<SpinnerSvg v-else class="fill-white" />
					</AppButton>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { useDialogStore } from '../../../stores/dialog'
	import { ref } from 'vue'
	import AppButton from '../../common/AppButton.vue'
	import CloseSvg from '../../VehicleForm/components/icons/CloseSvg.vue'
	import SpinnerSvg from '../../VehicleForm/components/icons/SpinnerSvg.vue'

	// hooks
	const dialogs = useDialogStore()

	// refs
	const loading = ref(false)

	// methods
	const handleDialogsClose = () => {
		dialogs.confirmationModal.open = false
		dialogs.confirmationModal.reject()
	}
	const onConfirm = () => {
		if (loading.value) return
		loading.value = true

		dialogs.confirmationModal
			.action()
			.then(dialogs.confirmationModal.resolve)
			.catch(dialogs.confirmationModal.reject)
			.finally(() => {
				dialogs.confirmationModal.open = false
				loading.value = false
			})
	}
</script>
